module.exports = __webpack_public_path__ + "img/image29.75fda0ef.webp";